const firebaseConfig = {
    apiKey: "AIzaSyBpxsbJlgsugSofjbeKoIZ7dKtf77qi70s",
    authDomain: "crypto-tracker-55abb.firebaseapp.com",
    projectId: "crypto-tracker-55abb",
    storageBucket: "crypto-tracker-55abb.appspot.com",
    messagingSenderId: "547949385153",
    appId: "1:547949385153:web:a5a2b5b4cf4b76840e8b40",
};

export default firebaseConfig;
